import {
  GET_CONFIG_FAILURE,
  GET_CONFIG_REQUEST,
  GET_CONFIG_SUCCESS,
  GET_AUDIENCE_TAGS_FAILURE,
  GET_AUDIENCE_TAGS_REQUEST,
  GET_AUDIENCE_TAGS_SUCCESS,
  MODE_SWITCHED,
  SET_FAILED_VALIDATIONS
} from './const';

/**
 * toggles the application mode
 * @param {string} applicationMode - ui application mode
 * @returns {object} an action object
 */
export const switchApplicationMode = applicationMode => ({
  type: MODE_SWITCHED,
  applicationMode
});

/**
 * sets failed validations
 * @param {object} failedValidations - object containing failed validations
 * @returns {object} an action object
 */
export const setFailedValidations = failedValidations => ({
  type: SET_FAILED_VALIDATIONS,
  failedValidations
});

/**
 * gets configurations from db request action
 * @returns {object} an action object
 */
export const getConfigRequest = () => ({
  type: GET_CONFIG_REQUEST
});

/**
 * gets configurations from db action
 * @param {object} config - object containing the configuration
 * @returns {object} an action object
 */
export const getConfigSuccess = config => ({
  type: GET_CONFIG_SUCCESS,
  config
});

/**
 * configuration Failure.
 * @param {object} error - error object returned by the API.
 * @returns {object} an action object
 */
export const getConfigFailure = error => ({
  type: GET_CONFIG_FAILURE,
  error
});

/**
 * gets audience tags request
 * @returns {object} an action object
 */
export const getAudienceTagsRequest = () => ({
  type: GET_AUDIENCE_TAGS_REQUEST
});

/**
 * gets audience tags success
 * @param {Array} audienceTags - array containing the audience tags
 * @returns {object} an action object
 */
export const getAudienceTagsSuccess = audienceTags => ({
  type: GET_AUDIENCE_TAGS_SUCCESS,
  audienceTags
});

/**
 * gets audience tags - failure
 * @param {object} error - error object returned by the API.
 * @returns {object} an action object
 */
export const getAudienceTagsFailure = error => ({
  type: GET_AUDIENCE_TAGS_FAILURE,
  error
});
